import BrandLogo from "../../components/BrandLogo";
import { useAppBrandInfo } from "../../hooks/useAppBrandInfo";
import bgAbstract from "../../assets/loginPattern.svg";
import UsernamePassword from "../../components/auth/UsernamePassword";
import LoginWithGoogle from "../../components/auth/LoginWithGoogle";

// const cookies = new Cookies();

function Login() {
  const { brandInfo } = useAppBrandInfo();
  return (
    <>
      <div className="layout-wrapper  h-screen bg-bodyBackground flex flex-col lg:flex-row overflow-hidden fixed w-full">
        <div
          className="w-full login-image-section lg:block hidden lg:w-[60%] h-[60%] lg:h-full loginPage-bgImage relative l"
          style={{
            backgroundImage: `url(${bgAbstract})`,
          }}
        >
          <div className=" p-10 lg:p-16 h-full flex flex-col justify-between content-wrapper">
            <div className="w-[280px] flex flex-col overflow-hidden text-end sidebar">
              <h1 className="hero-heading text-white text-2xl lg:text-5xl font-bold drop-shadow-md tracking-wider font-roboto">
                {brandInfo.app_name}
              </h1>
              <p className="text-white footer-credit">By iDigitize</p>
            </div>
            <div>
              <div className=" mt-10 lg:mt-0 mb-6 lg:mb-24 footer-content footer-heading">
                {/* Empower Your Workforce. */}
                <h3 className="footer-description drop-shadow-md text-white text-base lg:text-4xl mb-4 font-semibold">
                  {brandInfo.product_name}
                </h3>
                <p className=" footer-description text-white drop-shadow-md text-base lg:text-lg">
                  {brandInfo.product_description}
                </p>
              </div>
              <div className=" space-x-6">
                <a
                  href="http://"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" text-sm lg:text-base text-white drop-shadow-md hover:underline footer-links footer-text"
                >
                  Privacy Policy
                </a>
                <span className="text-white drop-shadow-md text-sm lg:text-base footer-text">
                  @ 2025, iDigitize I All Rights Reserved I Designed, Developed
                  & Managed By iDigitize Infotech LLP
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full auth-content lg:w-[40%] h-full lg:h-full flex flex-col items-center justify-center">
          <BrandLogo
            className="w-auto h-16 mb-5 logo-wrapper" // Adjust size as needed
          />
          <h1 className=" text-primary font-semibold text-3xl mb-10 section-heading">
            Welcome to {brandInfo.app_name}
          </h1>
          {/* {(AUTH_TYPE === 'BASIC' || AUTH_TYPE === 'BOTH') && */}
          <UsernamePassword />
          <div className="w-full flex justify-end mr-10 mt-10 forgot-password-wrapper">
            <a
              className="underline underline-offset-2 font-medium forgot-password-link"
              href="/forgot-password"
            >
              {" "}
              Forgot Password ?
            </a>
          </div>
          {/* // } */}
          {/* {AUTH_TYPE === 'BOTH' && */}
          <div className="my-4 w-[69.5%] text-center relative divider-wrapper">
            <div className="w-full bg-gray-300 h-px absolute top-1/2 divider-line"></div>
            <span className="bg-white px-4 relative z-10 text-gray-500 divider-text">
              OR
            </span>
          </div>
          {/* } */}
          <LoginWithGoogle />
        </div>
      </div>
    </>
  );
}

export default Login;
